var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close-menu"},[_c('span',{staticClass:"sr-only"},[_vm._v("Close menu for "+_vm._s(_vm.name))]),_c('span',{attrs:{"aria-hidden":""}},[_vm._v("Close")]),_c('i',{staticClass:"far fa-times"})])
}
var staticRenderFns = []

export { render, staticRenderFns }